import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { StudyNavigationService } from '../../services/study-navigation.service';

@Component({
    selector: 'app-countdown-timer',
    templateUrl: './countdown-timer.component.html',
    styleUrls: ['./countdown-timer.component.scss'],
    standalone: false
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  @Input() timer = 3;
  timerSub: Subscription;

  constructor(private navigationService: StudyNavigationService) {}

  ngOnInit(): void {
    this.timerSub = interval(1000).subscribe(() => {
      this.timer--;
      if (this.timer === 0) {
        this.navigationService.renderNext();
      }
    });
  }

  ngOnDestroy() {
    this.timerSub.unsubscribe();
  }
}
